import React from 'react';
import classnames from 'classnames';
import bentleyLogoDark from './bentley-logo-dark.svg';
import bentleyLogoLight from './bentley-logo-light.svg';

import './BentleyLogo.scss';

const BentleyLogo = ({
    classNames,
    isLoginPage,
}) => {
    const classes = classnames('b-bentley-logo', classNames);
    return (
        <div className={classes}>
            {isLoginPage ? <img src={bentleyLogoLight} alt="Bentley Logo Light" data-testid="bentley-logo" />
             : <img src={bentleyLogoDark} alt="Bentley Logo Dark" data-testid="bentley-logo" />}
            
        </div>
    );
};

export default BentleyLogo;

